const Document = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.3333 5.33334H12V13.3333C12 14.0697 12.597 14.6667 13.3333 14.6667C14.0697 14.6667 14.6667 14.0697 14.6667 13.3333V6.66668C14.6667 5.9303 14.0697 5.33334 13.3333 5.33334Z"
        fill="#6B50FF"
      />
      <path
        opacity="0.4"
        d="M9.99992 1.33334H3.33325C2.22868 1.33334 1.33325 2.22877 1.33325 3.33334V12.6667C1.33325 13.7712 2.22868 14.6667 3.33325 14.6667H13.3333C12.5969 14.6667 11.9999 14.0697 11.9999 13.3333V3.33334C11.9999 2.22877 11.1045 1.33334 9.99992 1.33334Z"
        fill="#6B50FF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.5 4.66666C3.5 4.39051 3.72386 4.16666 4 4.16666H9.33333C9.60948 4.16666 9.83333 4.39051 9.83333 4.66666C9.83333 4.9428 9.60948 5.16666 9.33333 5.16666H4C3.72386 5.16666 3.5 4.9428 3.5 4.66666Z"
        fill="#6B50FF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.5 8C3.5 7.72386 3.72386 7.5 4 7.5L9.33333 7.5C9.60948 7.5 9.83333 7.72386 9.83333 8C9.83333 8.27614 9.60948 8.5 9.33333 8.5L4 8.5C3.72386 8.5 3.5 8.27614 3.5 8Z"
        fill="#6B50FF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.5 11.3333C3.5 11.0572 3.72386 10.8333 4 10.8333H6.66667C6.94281 10.8333 7.16667 11.0572 7.16667 11.3333C7.16667 11.6095 6.94281 11.8333 6.66667 11.8333H4C3.72386 11.8333 3.5 11.6095 3.5 11.3333Z"
        fill="#6B50FF"
      />
    </svg>
  );
};

export default Document;
